export default function servicesDarkMode() {
	const darkModeButton = document.getElementsByClassName( 'dark-mode-widget' )[ 0 ];
	if ( ! darkModeButton ) {
		return;
	}
	const images = document.querySelectorAll( '.services-page img' );
	let isDark = localStorage.getItem( 'preslavNightMode' ) || false;

	if ( document.body.className.indexOf( 'dark-mode' ) > -1 ) {
		for ( let i = 0; i < images.length; i++ ) {
			images[ i ].src = images[ i ].src.replace( '.png', '-dark.png' );
			images[ i ].srcset = '';
		}
	}

	darkModeButton.addEventListener( 'click', function() {
		isDark = ! isDark;
		if ( isDark ) {
			for ( let i = 0; i < images.length; i++ ) {
				images[ i ].src = images[ i ].src.replace( '.png', '-dark.png' );
				images[ i ].srcset = '';
			}
		} else {
			for ( let i = 0; i < images.length; i++ ) {
				images[ i ].src = images[ i ].src.replace( '-dark.png', '.png' );
				images[ i ].srcset = '';
			}
		}
	} );
}
